import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const NoArticle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg width="130" height="149" viewBox="0 0 130 149" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <linearGradient x1="49.968%" y1="-2.316%" x2="49.968%" y2="101.076%" id="ewbllntoxc">
          <stop offset="0%" stopColor="#FDFEFF" />
          <stop offset="99.64%" stopColor="#ECF0F5" />
        </linearGradient>
        <filter
          x="-54.4%"
          y="-30.4%"
          width="208.8%"
          height="185%"
          filterUnits="objectBoundingBox"
          id="upi9gdmb5a"
        >
          <feOffset dy="11" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="11" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="m70.004 22.3.8 64.4c0 2.2-1.8 3.9-4 3.9H4c-2.2 0-4-1.8-4-3.9V3.9C0 1.7 1.8 0 4 0h45.504l20.5 22.3z"
          id="jk9tg4vgxb"
        />
      </defs>
      <g fill="none">
        <path
          d="M115.403 64.8c0 14.2-5.8 27-15.1 36.2-9.1 9.1-21.7 14.6-35.603 14.6-13.8 0-26.4-5.6-35.6-14.6C19.8 91.8 14 79 14 64.8 14 36.7 36.7 14 64.7 14c28.003 0 50.703 22.8 50.703 50.8zM117.703 24.499c2.26 0 4.1-1.835 4.1-4.1 0-2.264-1.84-4.1-4.1-4.1-2.27 0-4.1 1.836-4.1 4.1 0 2.265 1.83 4.1 4.1 4.1zM123.703 8.499c1.54 0 2.8-1.253 2.8-2.8 0-1.546-1.26-2.8-2.8-2.8-1.55 0-2.8 1.254-2.8 2.8 0 1.547 1.25 2.8 2.8 2.8zM12.3 27.399a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6zM14.2 117.4a5.2 5.2 0 1 0-.001-10.401A5.2 5.2 0 0 0 14.2 117.4z"
          fill="#EAEEF9"
        />
        <g>
          <g transform="translate(30 25)">
            <use fill="#000" filter="url(#upi9gdmb5a)" xlinkHref="#jk9tg4vgxb" />
            <use fill="url(#ewbllntoxc)" xlinkHref="#jk9tg4vgxb" />
          </g>
          <path
            d="M62.7 38.499H40.6c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h22.1c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zM52.2 45.7H40.6c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h11.5c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.2 1.3zM79.504 25v17.8c0 2.5 2.2 4.5 4.7 4.5h15.8"
            fill="#D5DDEA"
          />
          <path
            d="M52.042 91.168c-.42 0-.756-.168-1.092-.42-.588-.588-.588-1.597 0-2.185 3.864-3.78 8.989-5.881 14.45-5.881a20.562 20.562 0 0 1 14.454 5.881c.58.588.58 1.597 0 2.185-.59.588-1.6.588-2.19 0-3.27-3.277-7.643-5.041-12.264-5.041-4.621 0-8.989 1.764-12.266 5.041-.336.252-.672.42-1.092.42zM57.335 68.652l2.016-2.016c.588-.588.588-1.596 0-2.184-.588-.589-1.596-.589-2.184 0l-2.016 2.016-2.017-2.016c-.588-.589-1.596-.589-2.184 0-.588.588-.588 1.596 0 2.184l2.016 2.016-2.016 2.017c-.588.588-.588 1.596 0 2.184.336.336.672.42 1.092.42.42 0 .756-.168 1.092-.42l2.017-2.016 2.016 2.016c.336.336.672.42 1.092.42.42 0 .756-.168 1.092-.42.588-.588.588-1.596 0-2.184l-2.016-2.017zM77.754 68.652l2.01-2.016c.59-.588.59-1.596 0-2.184a1.566 1.566 0 0 0-2.18 0l-2.02 2.016-2.01-2.016c-.59-.589-1.601-.589-2.189 0-.588.588-.588 1.596 0 2.184l2.019 2.016-2.019 2.017c-.588.588-.588 1.596 0 2.184.336.336.672.42 1.092.42.42 0 .757-.168 1.097-.42l2.01-2.016 2.02 2.016c.33.336.67.42 1.09.42.42 0 .76-.168 1.09-.42.59-.588.59-1.596 0-2.184l-2.01-2.017z"
            fill="#989FB0"
          />
        </g>
        <path
          stroke="#A2ABBE"
          d="m47.98 18.265-3.782-5.692M58.065 15.419 58.509 1M67.107 18.4l6.036-13.103"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

NoArticle.displayName = 'NoArticle';
